import AccordionInstance from '@r1-frontend/ui-react/deprecated/Accordion';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React from 'react';
import styled from 'styled-components';

import { getMedia } from '../../../helpers/layout';

export const Wrap = styled.div`
    display: block;
    min-height: calc(100vh - 136px);
    background: #F7F7F8;
    padding: 100px 120px;

    @media only screen and ${getMedia('tablet', 'phone')} {
        padding: 100px 70px;
        min-height: 0;
    }

    @media only screen and ${getMedia('phone')} {
        padding: 60px 20px;
        min-height: 0;
    }
`;

export const Title = styled.div`
    ${FONTS.H1};
    margin-bottom: 30px;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        ${FONTS.H2};
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        ${FONTS.H2};
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.H3};
    }
`;

export const Accordion = styled(AccordionInstance)`
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
`;

export const Content = styled.div`
    display: block;
    ${FONTS.S};

    p {
      margin: 10px 0;
    }

    ul {
      margin: 10px 0;

      li {
        &::before {
          content: "-";
          margin-right: 10px;
        }
      }
    }
`;

const FAQ = ({ price, ...props }) => <Wrap {...props}>
    <Title as='h2'>Частые вопросы</Title>
    <Accordion title='На каких устройствах доступна услуга?'>
        <Content>
            <p>Услуга доступна Клиентам со Smart TV и приставками:</p>
            <ul>
                <li>Movix и Movix Pro</li>
                <li>Humax 9000i</li>
                <li>Humax 7000i</li>
                <li>Kaon HD 6000i</li>
                <li>Mag 250/G-Box и IMAQLIQ</li>
            </ul>
            <p>Также воспользоваться услугой можно на сайте и в мобильном приложении Дом.ру Movix.</p>
        </Content>
    </Accordion>
    <Accordion title='Какие ТВ-каналы я могу смотреть с услугой «Управляй&nbsp;просмотром»?'>
        <Content>
            <p>Передачи доступны на каналах и пакетах каналов, которые входят в ваш тариф. На местных каналах и канале «Дом.ру Гид HD» услуга недоступна.</p>
        </Content>
    </Accordion>
    <Accordion title='Условия подключения'>
        <Content>
            <p>Стоимость услуги — {price} р/мес. Минимальный срок подключения услуги — 30 дней.</p>
        </Content>
    </Accordion>
</Wrap>;

export default FAQ;
